import { call, put, takeEvery } from 'redux-saga/effects';
import {
  ANALYZE_TYPOLOGIES,
  analyzeTypologiesSuccess,
  analyzeTypologiesFailed
} from '../../redux/actions/trm/typologyAnalyzer';
import { postDataToServer } from '../../services/util';

function* analyzeTypologiesWorker(action) {
  try {
    const { afcTypologyIds, dynamicProperties = {}, afcToken } = action.payload;
    const serviceApi = localStorage.getItem('service-api') || '';
    const data = { afcTypologyIds, dynamicProperties, ...(afcToken ? { afcToken } : {}) };

    // On localhost, proxy through agent service to avoid CORS
    let url;
    if (window.location.hostname === 'localhost') {
      const agentApi = localStorage.getItem('service-api-agent') || 'http://localhost:8090';
      url = `${agentApi}/chat/proxy/caas`;
      data._caasUrl = serviceApi;
      data._caasPath = '/common/caas/typologyAnalysis';
    } else {
      url = `${serviceApi}/common/caas/typologyAnalysis`;
    }
    const response = yield call(postDataToServer, url, data);

    if (response && response.typologies) {
      yield put(analyzeTypologiesSuccess(response));
    } else {
      const errorMsg = response?.explain
        ? `${response.message}: ${response.explain}`
        : response?.message || 'Failed to analyze typologies';
      yield put(analyzeTypologiesFailed(errorMsg));
    }
  } catch (error) {
    yield put(analyzeTypologiesFailed(error.message || 'An error occurred'));
  }
}

export function* watchAnalyzeTypologies() {
  yield takeEvery(ANALYZE_TYPOLOGIES, analyzeTypologiesWorker);
}
